import { useEffect } from 'react';

const PreteachSliderNav = (props) => {
  const buttonClick = (index) => {
    if (props.currentSlide > index) {
      props.navButtonhandler(index);
    }
  };

  useEffect(() => {}, [props.currentSlide]);

  return (
    <div className="preteach__slider-nav">
      {
        <ul>
          {props.dotsData.map((data, index) => (
            <li
              onClick={() => buttonClick(index)}
              className={
                props.currentSlide > index
                  ? 'active'
                  : props.currentSlide === index
                  ? 'current'
                  : ''
              }
              key={index}
            >
              {index}
            </li>
          ))}
        </ul>
      }
    </div>
  );
};

export default PreteachSliderNav;
